import React from 'react';
import { Link } from 'react-router-dom';

interface LogoLinkProps {
  className?: string;
  imgClassName?: string;
}

const LogoLink: React.FC<LogoLinkProps> = ({ className, imgClassName }) => {
  return (
    <Link to="/" className={className} aria-label="Home">
      <img
        src="/logo.png"
        alt="World Of Racing"
        className={imgClassName}
        style={{ height: 115.2, width: 'auto' }}
        onError={(e) => {
          const target = e.currentTarget as HTMLImageElement;
          target.onerror = null;
          target.src = '/logo192.png';
        }}
      />
    </Link>
  );
};

export default LogoLink;


